import { createTheme } from "@mui/material/styles";
import { plPL } from "@mui/x-date-pickers/locales";
import { featureFlags } from "./featureFlags/featureFlags";

/** Default MUI palette and shape with Polish date-picker locale. */
export const theme1 = createTheme(
  {
    colorSchemes: {
      light: {
        palette: featureFlags.enabled("packages2.0") ? { background: { default: "#f4f6f8" } } : {},
      },
    },
  },
  plPL,
);

/** Brand theme: #3557a1 primary, 16px rounded surfaces and sentence-case buttons. */
export const theme2 = createTheme(
  {
    palette: {
      primary: {
        main: "#3557a1",
      },
      background: {
        default: "#f4f6f8",
      },
    },
    shape: {
      borderRadius: 16,
    },

    typography: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      button: {
        textTransform: "none",
        fontWeight: 600,
      },
    },
    components: {
      MuiCard: {
        styleOverrides: {
          root: {
            boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.04)",
            border: "1px solid rgba(0,0,0,0.05)",
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: 8,
          },
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            "&:not(.Mui-disabled):hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "#3557a1",
            },
          },
        },
      },
    },
  },
  plPL,
);
